import * as React from "react";
import PropTypes from 'prop-types';

const RenameTextField = (props) => {
    const { source, record, types = {}, target } = props;
    if (!record) return (<span>Loading..</span>);

    function shortenType(data) {
        try {
            let returnType = ''
            for (let type of types)
                if (type.id === data) returnType = type[target];
            return returnType
        } catch (e) {
            return data
        }
    }
    return (<span>
        {shortenType(record[source])}
    </span>);
}
RenameTextField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    types: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired
};

export default RenameTextField;